<template>
  <div>
    <a-card hoverable>
      <a-spin :spinning="histLoading">
        <a-steps size="small">
          <a-step title="REGISTRADA" :description="creationDate" status="finish"></a-step>
          <a-step v-for="step in historico"
                  :title="step.description"
                  :description="step.action_date"
                  :status="getStepStatus(step)"
                  v-if="stepVisible(step)">
            <a-icon type="clock-circle-o" slot="icon" v-if="getStepStatus(step) === 'wait'"/>
          </a-step>
        </a-steps>
      </a-spin>
    </a-card>
    <a-row>&nbsp;</a-row>
    <a-descriptions bordered size="small">
      <a-descriptions-item :label="$t('Estado')">
        <a-badge style="min-width: 80px;"
                 :status="reqRechazada?'error':
                        (reqCerrada?'success':'processing')" :text="requisicion.estado"/>
      </a-descriptions-item>
      <a-descriptions-item :label="$t('Requisición')">{{requisicion.req_id}}</a-descriptions-item>
      <a-descriptions-item :label="$t('Número de Vacantes')">{{requisicion.vacant}}</a-descriptions-item>
      <a-descriptions-item :label="$t('Tipo de Solicitud')">{{requisicion.tipo_sol}}</a-descriptions-item>
      <a-descriptions-item :label="$t('Motivo')">{{requisicion.motivo}}</a-descriptions-item>
      <a-descriptions-item :label="$t('Cargo')">{{requisicion.cargo}}</a-descriptions-item>
      <a-descriptions-item :label="$t('Oficina')"
                           v-if="$getConfigValue('MOSTRAR_OFICINA_EN_REQUISICION', false) === 'SI'">
        {{requisicion.oficina}}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('Ocupante Anterior')">{{requisicion.nombre_ocupante}}</a-descriptions-item>
      <a-descriptions-item :label="$t('Cargo Ocupante Anterior')">{{requisicion.cargo_ocupante}}</a-descriptions-item>

      <a-descriptions-item :label="$t('Compañia')">{{requisicion.company_desc}}</a-descriptions-item>
      <a-descriptions-item :label="$t('Cuidad de Labores')">{{requisicion.id_h_labor_city_desc}}</a-descriptions-item>
      <a-descriptions-item :label="$t('Centro de Costo')">{{requisicion.cc_id_desc}}</a-descriptions-item>
      <a-descriptions-item :label="$t('Fecha Inicio Labores')">{{requisicion.effective_date_desc}}</a-descriptions-item>
      <a-descriptions-item :label="$t('Salario')">{{requisicion.salary}}</a-descriptions-item>

      <a-descriptions-item :label="$t('Tipo de Contrato')">{{requisicion.contract_type_desc}}</a-descriptions-item>
      <a-descriptions-item :label="$t('Agencia')">{{requisicion.id_h_agency_desc}}</a-descriptions-item>
      <a-descriptions-item :label="$t('Empleado Autoriza')">{{requisicion.nombre_auto}}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('Cargo Autoriza')">{{requisicion.cargo_auto}}
      </a-descriptions-item>
      <a-descriptions-item v-if="!isHRReq" :label="$t('Estado Proceso RH')">{{requisicion.estado_prc_rh}}
      </a-descriptions-item>
      <a-descriptions-item v-if="!isHRReq" :label="$t('Cubrimiento Vacante')">{{requisicion.cubrimiento_vacante}}
      </a-descriptions-item>
      <a-descriptions-item v-if="!isHRReq" :label="$t('Elementos Requeridos')">{{requisicion.elementos_requeridos}}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('Observaciones')">{{requisicion.observacion}}</a-descriptions-item>
    </a-descriptions>
    <a-row>&nbsp;</a-row>
    <a-collapse accordion>
      <a-collapse-panel header="Logística del Cargo" key="1">
        <a-tooltip slot="extra" v-if="isHRReq">
          <template slot="title">
            Agregar Elemento
          </template>
          <a-icon type="plus-circle" style="color: green; font-size: 20px" @click="registrarAsset"/>
        </a-tooltip>
        <a-descriptions bordered size="small">
          <a-descriptions-item v-for="(log, index) in requisicion.job_assets" :label="log.h_asset">
            <a-icon type="check-circle" style="color: #52c41a; margin-right: 5px"/>
            <a-tooltip>
              <template slot="title">
                Eliminar
              </template>
              <a-icon type="delete" style="color: red" @click="retirarElemento(log, index)" v-if="isHRReq"/>
            </a-tooltip>
          </a-descriptions-item>
          <a-descriptions-item v-for="log in requisicion.logistica_cargo" :label="log.valor">
            <a-icon type="check-circle" style="color: #52c41a;"/>
          </a-descriptions-item>
        </a-descriptions>
      </a-collapse-panel>
    </a-collapse>
    <a-row>&nbsp;</a-row>
    <a-spin :spinning="loading">
      <a-tabs defaultActiveKey="1" v-if="isHRReq">
        <a-tab-pane tab="INFORMACIÓN DEL CARGO" key="1">
          <a-descriptions bordered size="small"
                          v-if="iRequisicion.status === status.REQUISICIONES_ETAPA_CERRADA || iRequisicion.status === status.REQUISICIONES_ETAPA_FINALIZADA">
            <a-descriptions-item :label="$t('Estado Proceso RH')">{{requisicion.estado_prc_rh}}</a-descriptions-item>
            <a-descriptions-item  v-if="$getConfigValue('REQUISICIONES_CUBRIMIENTO_VACANTE_USA_DROPDOWN', false) === 'SI'" :label="$t('Cubrimiento Vacante')">{{requisicion.cubrimiento_vacante}}</a-descriptions-item>
            <a-descriptions-item :label="$t('Elementos Requeridos')"> {{requisicion.elementos_requeridos}}</a-descriptions-item>
            <a-descriptions-item :label="$t('Cuidad de Labores')">{{requisicion.id_h_labor_city_desc}}</a-descriptions-item>
            <a-descriptions-item :label="$t('Fecha Inicio Labores')">{{requisicion.effective_date_desc}}</a-descriptions-item>
            <a-descriptions-item :label="$t('Requiere Visita')">{{requiereVista}}</a-descriptions-item>
            <a-descriptions-item :label="$t('Salario Personalizado')">{{salarioPer}}</a-descriptions-item>
            <a-descriptions-item :label="$t('Salario')">$ {{requisicion.salary}}</a-descriptions-item>
            <a-descriptions-item :label="$t('Tipo de Contrato')">{{requisicion.contract_type_desc}}</a-descriptions-item>
            <a-descriptions-item  v-if="$getConfigValue('MOSTRAR_FORM_EN_REQUISICION', false) === 'SI'"
                                  label="Formulario: ">{{requisicion.name_form}}</a-descriptions-item>
          </a-descriptions>
          <a-form-model :model="iRequisicion" v-bind="fiOptions" :rules="formRules" @submit="gestionarRequisicion"
                        @submit.native.prevent ref="requisicionesForm"
                        v-if="iRequisicion.status !== status.REQUISICIONES_ETAPA_CERRADA && iRequisicion.status !== status.REQUISICIONES_ETAPA_FINALIZADA">
            <a-row :gutter="[16,2]">
              <a-col v-bind="colConfig">
                <a-form-model-item :label="$t('Estado Proceso RH')" prop="process_status" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       endpoint="hierarchy_lookup"
                                       v-model="iRequisicion.process_status"
                                       :params="process_status_params">
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colConfig">
                <a-form-model-item :label="$t('Cubrimiento Vacante')" prop="req_obs3" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       endpoint="hierarchy_lookup"
                                       v-model="iRequisicion.req_obs3"
                                       :params="req_obs3_params"
                                       v-if="$getConfigValue('REQUISICIONES_CUBRIMIENTO_VACANTE_USA_DROPDOWN', false) === 'SI'"
                  >
                  </form-model-dropdown>
                  <form-model-lookup style="width: 100%"
                                     endpoint="hierarchy_lookup"
                                     v-model="iRequisicion.req_obs3"
                                     :params="req_obs3_params"
                                     v-else
                  >
                  </form-model-lookup>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colConfig">
                <a-form-model-item :label="$t('Elementos Requeridos')" prop="req_obs4">
                  <a-textarea autoSize v-model="iRequisicion.req_obs4"/>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colConfig">
                <a-form-model-item :label="$t('Ciudad de Labores')" prop="id_h_labor_city" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       endpoint="hierarchy_lookup_domains"
                                       v-model="iRequisicion.id_h_labor_city"
                                       :params="city_req"
                  >
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colConfig">
                <a-form-model-item :label="$t('Fecha Inicio Labores')" prop="effective_date">
                  <a-date-picker
                    v-model="iRequisicion.effective_date"
                    type="date"
                    style="width: 100%;"
                    valueFormat="Y-MM-DD HH:mm:ss"
                  />
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colConfig">
                <a-form-model-item :has-feedback="false" prop="requiere_visita" :label="$t('Requiere Visita')">
                  <form-model-checkbox v-model="iRequisicion.requiere_visita">
                  </form-model-checkbox>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colConfig">
                <a-form-model-item :label="$t('Salario Personalizado')" prop="custom_salary">
                  <form-model-checkbox v-model="iRequisicion.custom_salary">
                  </form-model-checkbox>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colConfig" v-show="iRequisicion.custom_salary">
                <a-form-model-item v-bind="fiOptions" required :label="$t('Salario')" prop="salary" has-feedback>
                  <a-input-number style="width: 100%" step="1"
                                  v-model=iRequisicion.salary
                                  :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                  :parser="value => value.replace(/\$\s?|(,*)/g, '')">
                  </a-input-number>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colConfig" v-show="!iRequisicion.custom_salary" prop="ddSaari">
                <a-form-model-item required :label="$t('Salario')" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       endpoint="req_salary"
                                       v-model="iRequisicion.ddSaari"
                                       :params="salary_req"
                  >
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colConfig">
                <a-form-model-item :label="$t('Tipo de Contrato')" prop="contract_type" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       endpoint="hierarchy_lookup"
                                       v-model="iRequisicion.contract_type"
                                       :params="contract_req"
                  >
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colConfig">
                <a-form-model-item v-if="$getConfigValue('MOSTRAR_FORM_EN_REQUISICION', false) === 'SI'"
                                   label="Formulario: " prop="id_form" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       endpoint="forms"
                                       v-model="iRequisicion.id_form"
                  >
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>
              <a-col :span="24" style="text-align: right">
                <a-button
                  type="primary"
                  html-type="submit">
                  Guardar
                </a-button>
              </a-col>
            </a-row>
          </a-form-model>
        </a-tab-pane>
        <a-tab-pane tab="ACTUALIZAR REQUISICIÓN" key="2">
          <a-descriptions bordered size="small"
                          v-if="iRequisicion.status === status.REQUISICIONES_ETAPA_CERRADA || iRequisicion.status === status.REQUISICIONES_ETAPA_FINALIZADA">
            <a-descriptions-item :label="$t('Tipo de Solicitud')">{{requisicion.tipo_sol}}</a-descriptions-item>
            <a-descriptions-item :label="$t('Motivo de Solicitud')">{{requisicion.motivo}}</a-descriptions-item>
            <a-descriptions-item :label="$t('Ocupante Anterior')">{{requisicion.nombre_ocupante}}</a-descriptions-item>
            <a-descriptions-item v-show="mostrarOcupanteAnerior" :label="$t('Cargo Oc. Aterior')">{{requisicion.cargo_ocupante}}</a-descriptions-item>
            <a-descriptions-item :label="$t('Compañia')">{{requisicion.company_desc}}</a-descriptions-item>
            <a-descriptions-item :label="$t('Oficina')">{{requisicion.oficina}}</a-descriptions-item>
            <a-descriptions-item :label="$t('PERSONALIZACION_CENTRO_COSTO_CENTRO_DE_COSTOS')">{{requisicion.cc_id_desc}}</a-descriptions-item>
            <a-descriptions-item :label="$t('Cargo')">{{requisicion.cargo}}</a-descriptions-item>
            <a-descriptions-item :label="$t('Cantidad de Vacantes')">{{requisicion.vacant}}</a-descriptions-item>
            <a-descriptions-item :label="$t('Observaciones')">{{requisicion.observacion}}</a-descriptions-item>
          </a-descriptions>
          <a-form-model :model="iRequisicion" v-bind="fiOptions" :rules="actualizarRequisicionRules"
                        @submit="actualizarRequisicion"
                        @submit.native.prevent ref="actualizarRequisicionesForm"
                        v-if="iRequisicion.status !== status.REQUISICIONES_ETAPA_CERRADA && iRequisicion.status !== status.REQUISICIONES_ETAPA_FINALIZADA">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colConfig">
                <a-form-model-item :label="$t('Tipo de Solicitud')" prop="req_type_id" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       endpoint="hierarchy_lookup"
                                       v-model="iRequisicion.req_type_id"
                                       :selectedObj.sync="iRequisicion.tipoSolicitudSeleccionado"
                                       :params="{h_lookup_type: 'TIPO_REQUISICION'}">
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colConfig">
                <a-form-model-item :label="$t('Motivo de Solicitud')" prop="req_mot_id" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       endpoint="hierarchy_lookup"
                                       v-model="iRequisicion.req_mot_id"
                                       :selectedObj.sync="iRequisicion.motivoSolicitudSeleccionado"
                                       :params="reqMotParams">
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colConfig"
                     v-show="mostrarOcupanteAnerior">
                <a-form-model-item :label="$t('Ocupante Anterior')" prop="id_emp_bef" has-feedback>
                  <form-model-lookup style="width: 100%"
                                     :selectedObj.sync="iRequisicion.ocupanteAntSeleccionado"
                                     endpoint="empleados"
                                     v-model="iRequisicion.id_emp_bef"
                  >
                  </form-model-lookup>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colConfig"
                     v-show="mostrarOcupanteAnerior">
                <a-form-model-item :label="$t('Cargo Oc. Aterior')" has-feedback>
                  <a-input readOnly
                           :value="iRequisicion.ocupanteAntSeleccionado && iRequisicion.ocupanteAntSeleccionado.cargo"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colConfig">
                <a-form-model-item :label="$t('Compañía')" prop="id_company" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       endpoint="company"
                                       v-model="iRequisicion.id_company">
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colConfig">
                <a-form-model-item :label="$t('Oficina')" prop="office_id" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       endpoint="cc_offices"
                                       :params="officeParams"
                                       v-model="iRequisicion.office_id">
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>

              <a-col v-bind="colConfig">
                <a-form-model-item :label="$t('PERSONALIZACION_CENTRO_COSTO_CENTRO_DE_COSTOS')" prop="cc_id"
                                   has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       endpoint="cc_offices"
                                       :params="ccParams"
                                       :selectedObj.sync="centroCostoSeleccionado"
                                       v-model="iRequisicion.cc_id">
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colConfig">
                <a-form-model-item :label="$t('Cargo')" prop="position_id" has-feedback>
                  <form-model-dropdown style="width: 100%"
                                       endpoint="cc_jobs"
                                       :params="jobParams"
                                       v-model="iRequisicion.position_id">
                  </form-model-dropdown>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colConfig">
                <a-form-model-item :label="$t('Cantidad de Vacantes')" prop="vacant" has-feedback>
                  <a-input-number style="width: 100%;"
                                  v-model="iRequisicion.vacant">
                  </a-input-number>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colConfig">
                <a-form-model-item :label="$t('Observaciones')" prop="req_obs2" has-feedback>
                  <a-textarea
                    autoSize
                    v-model="iRequisicion.req_obs2">
                  </a-textarea>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-alert
                  message="Información del centro de costo"
                  v-if="infoCc"
                  type="info"
                  show-icon>
                  <div slot="description" v-html="infoCc"></div>
                </a-alert>
              </a-col>
              <a-col :span="24" style="text-align: right">
                <a-button
                  type="primary"
                  html-type="submit">
                  Actualizar
                </a-button>
              </a-col>
            </a-row>
          </a-form-model>
        </a-tab-pane>
      </a-tabs>
    </a-spin>
    <a-modal title="Registrar Elemento"
             :visible="agregareElementoModal.visible"
             @ok="confirmarAgregarElemento"
             :confirmLoading="agregareElementoModal.loading"
             @cancel="cancelarAgregarElemento">
      <a-form-model :model="iRequisicion" v-bind="fiOptions">
        <a-form-model-item :label="$t('Elemento')" prop="vistaCampo" has-feedback>
          <form-model-dropdown style="width: 100%"
                               :selectedObj.sync="agregareElementoModal.elemento"
                               endpoint="hierarchy_lookup"
                               v-model="vistaCampo"
                               :params="{h_lookup_type: 'LOGISTICA_CARGO'}"
          >
          </form-model-dropdown>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import UserUtil from 'CustomModules/GlobalBPOCore/Util/UserUtil'

  export default {
    data () {
      return {
        vistaCampo: '',
        iRequisicion: {},
        formRules: {},
        actualizarRequisicionRules: {},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colConfig: {
          sm: 24,
          md: 12
        },
        empleadoAutorizaSeleccionado: {},
        uen_params: {h_lookup_domain: 'UEAN'},
        line_params: {h_lookup_domain: 'LINEA'},
        operation_params: {h_lookup_domain: 'OPER'},
        process_status_params: {h_lookup_type: 'ESTADO_PROCESO_REQ', use_code: true},
        req_obs3_params: {h_lookup_type: 'CUBRIMIENTO_VACANTE', use_code: true},
        city_req: {h_lookup_domain: 'CIUDAD_LAB'}, // h_lookup_type: 'CIUDADES_HV'},
        grupo_req: {h_lookup_type: 'ID_H_ATT1'},
        contract_req: {h_lookup_type: 'TIPO_CONTRATO'},
        category_req: {h_lookup_type: 'CATEGORIA'},
        tipo_cargo_params: {h_lookup_type: 'CLASIFICACION_CARGO'},
        agency_params: {h_lookup_type: 'REQ_AGENCIA'},
        tiempo_req_params: {h_lookup_type: 'TIEMPO_REQ', use_code: true},
        loading: false,
        agregareElementoModal: {
          visible: false,
          loading: false,
          elemento: {}
        },
        defaultReqData: {},
        activaListasCentroCosto: false,
        centroCostoSeleccionado: {},
        historico: [],
        histLoading: false,
        status: {
          REQUISICIONES_ETAPA_INICIADA: '00',
          REQUISICIONES_ETAPA_ABIERTA: '00',
          REQUISICIONES_ETAPA_FINALIZADA: '00',
          REQUISICIONES_ETAPA_CERRADA: '00',
          REQUISICIONES_ETAPA_RECHAZADA: '00'
        }
      }
    },
    props: ['requisicion'],
    mounted () {
      this.httpClient = new HttpUtil('gestion_humana/requisiciones')
      this.initFormRules()

      let grupo = this.$getConfigValue('REQUISICIONES_DEFAULT_GRUPO', null)
      let puesto = this.$getConfigValue('REQUISICIONES_DEFAULT_PUESTO', null)
      let categoria = this.$getConfigValue('REQUISICIONES_DEFAULT_CATEGORIA', null)

      this.defaultReqData.id_h_grupo_trabajo = JsUtils.isEmpty(grupo) ? null : grupo
      this.defaultReqData.id_h_puesto_trabajo = JsUtils.isEmpty(puesto) ? null : puesto
      this.defaultReqData.id_h_category = JsUtils.isEmpty(categoria) ? null : categoria

      this.iRequisicion = {...this.requisicion}
      this.setDefault()
      this.activaListasCentroCosto = this.$getConfigValue('REQUISICIONES_ACTIVA_LISTAS_CENTRO_COSTO', 'NO') === 'SI'

      this.status.REQUISICIONES_ETAPA_INICIADA = this.$getConfigValue('REQUISICIONES_ETAPA_INICIADA', '00')
      this.status.REQUISICIONES_ETAPA_ABIERTA = this.$getConfigValue('REQUISICIONES_ETAPA_ABIERTA', '00')
      this.status.REQUISICIONES_ETAPA_FINALIZADA = this.$getConfigValue('REQUISICIONES_ETAPA_FINALIZADA', '00')
      this.status.REQUISICIONES_ETAPA_CERRADA = this.$getConfigValue('REQUISICIONES_ETAPA_CERRADA', '00')
      this.status.REQUISICIONES_ETAPA_RECHAZADA = this.$getConfigValue('REQUISICIONES_ETAPA_RECHAZADA', '00')
    },
    methods: {
      initFormRules () {
        let requerido = [{required: true, message: 'Valor requerido'}]
        this.formRules = {
          process_status: [{required: true, message: 'Valor requerido'}],
          id_h_uen: [{required: true, message: 'Valor requerido'}],
          id_emp_authorizes: [{required: true, message: 'Valor requerido'}],
          contract_type: [{required: true, message: 'Valor requerido'}],
          salary: [{required: true, message: 'Valor requerido'}]
        }
        this.actualizarRequisicionRules = {
          req_type_id: requerido,
          req_mot_id: requerido,
          id_company: requerido,
          id_h_value1: requerido,
          office_id: requerido,
          position_id: requerido,
          vacant: requerido,
          id_h_agency: requerido,
          req_obs2: requerido,
          cc_id: requerido
        }
      },
      gestionarRequisicion () {
        if (this.loading) return
        this.$refs.requisicionesForm.validate(valid => {
          if (valid) {
            this.loading = true
            if (!this.iRequisicion.custom_salary) {
              this.iRequisicion.salary = this.iRequisicion.ddSaari
            }
            this.httpClient.getInstance().put('gestion_humana/requisiciones/' + this.iRequisicion.req_id, {
              id: this.iRequisicion.req_id,
              id_job_authorizes: JsUtils.isEmpty(this.empleadoAutorizaSeleccionado.id_cargo) ? this.iRequisicion.id_cargo_auto : this.empleadoAutorizaSeleccionado.id_cargo,
              ...this.iRequisicion
            }).then((response) => {
              if (JsUtils.isEmpty(response.data)) {
                Mensajes.error('Error', 'No fue posible actualizar la requisición.')
              } else {
                if (parseInt(response.data.resultado) === 2) {
                  this.$emit('update:requisicion', response.data.record)
                  this.$emit('reqUpdated')
                  Mensajes.success('Correcto', 'Información actualizada correctamente.')
                } else {
                  Mensajes.error('Error', response.data.mensaje)
                }
              }
            }).catch(() => {
              Mensajes.error('Error', 'No fue posible actualizar la requisición.')
            }).then(() => {
              this.loading = false
            })
          }
        })
      },
      retirarElemento (logisticAsset, index) {
        this.$confirm({
          title: 'Confirmación',
          content: '¿Está seguro que desea retirar el elemento ' + logisticAsset.h_asset + '?',
          onOk: () => {
            return new Promise((resolve, reject) => {
              this.httpClient.getInstance()
                .delete('gestion_humana/requisiciones/req_job_assets/' + logisticAsset.id)
                .then(response => {
                  try {
                    this.iRequisicion.job_assets.splice(index, 1)
                  } catch (e) {
                    console.log('error', e)
                  }

                  resolve()
                })
                .catch((error) => {
                  Mensajes.error('Error', 'No fue posible eliminar el elemento. Contacte al adminsitrador.')
                  reject(error)
                })
            })
          },
          onCancel () {
            //
          }
        })
      },
      registrarAsset (e) {
        e.stopPropagation()
        this.agregareElementoModal.visible = true
      },
      cancelarAgregarElemento () {
        if (this.agregareElementoModal.loading) {
          return
        }
        this.agregareElementoModal.visible = false
      },
      confirmarAgregarElemento () {
        if (!JsUtils.isEmpty(this.agregareElementoModal.elemento)) {
          this.agregareElementoModal.loading = true
          this.httpClient.getInstance().post('gestion_humana/requisiciones/req_job_assets', {
            req_id: this.iRequisicion.req_id,
            id_h_asset: this.agregareElementoModal.elemento.value
          })
            .then(response => {
              Mensajes.success('Correcto', 'Elemento registrado correctamente')
              try {
                this.agregareElementoModal.valor = ''
                this.agregareElementoModal.visible = true
                this.vistaCampo = ''
                this.iRequisicion.job_assets.push(response.data)
                this.agregareElementoModal.loading = false
              } catch (e) {
                console.log('error', e)
              }
            })
            .catch(() => {
              Mensajes.error('Error', 'No fue posible registrar el elemento. Contacte al adminsitrador.')
              this.agregareElementoModal.loading = false
            })
            .then(() => {
              this.agregareElementoModal.loading = false
            })
        }
      },
      setDefault () {
        for (let prop in this.defaultReqData) {
          if (this.defaultReqData.hasOwnProperty(prop)) {
            if (JsUtils.isEmpty(this.iRequisicion[prop])) {
              this.iRequisicion[prop] = this.defaultReqData[prop]
            }
          }
        }
      },
      actualizarRequisicion () {
        if (this.loading) return
        this.$refs.actualizarRequisicionesForm.validate(valid => {
          if (valid) {
            this.loading = true
            this.httpClient.getInstance().post('gestion_humana/requisiciones/actualizar_datos_basicos', this.$undefinedToNull(this.iRequisicion)).then((response) => {
              Mensajes.success('Correcto', 'Información actualizada correctamente.')
              this.$emit('reqUpdated')
            }).catch((error) => {
              Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible actualizar la requisición.'))
            }).then(() => {
              this.loading = false
            })
          }
        })
      },
      loadHistorico () {
        this.histLoading = true
        this.httpClient.getInstance().get('gestion_humana/requisiciones/historico/' + this.iRequisicion.req_id).then((response) => {
          this.historico = response.data
        }).catch((error) => {
          Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible cargar el histórico de la requisición.'))
          this.historico = []
        }).then(() => {
          this.histLoading = false
        })
      },
      getStepStatus (step) {
        if (this.iRequisicion.status === this.status.REQUISICIONES_ETAPA_RECHAZADA) {
          return 'error'
        }

        if (parseInt(this.iRequisicion.status) === parseInt(step.code)) {
          return 'process'
        }

        if (step.action_date === null) {
          return 'wait'
        }
        return 'finish'
      },
      stepVisible (step) {
        if (this.iRequisicion.status !== this.status.REQUISICIONES_ETAPA_RECHAZADA) {
          if (step.code === this.status.REQUISICIONES_ETAPA_RECHAZADA) {
            return false
          }
          return true
        }
        return step.action_date === null
      }
    },
    computed: {
      isHRReq () {
        return UserUtil.isInRol('HRReq') || UserUtil.isInRol('GestionarReq')
      },
      puesto_req () {
        return {
          // por solicitud de KR se cambia puesto_turno por id_h_att2 15/04/2020
          h_lookup_type: 'ID_H_ATT2',
          id_h_lookup_father: this.iRequisicion.id_h_grupo_trabajo
        }
      },
      salary_req () {
        return {
          oficina: this.iRequisicion.office_id,
          cargo: this.iRequisicion.position_id
        }
      },
      cc_line_params () {
        return {
          unit_id: this.iRequisicion.id_h_uen
        }
      },
      cc_operation_params () {
        return {
          unit_id: this.iRequisicion.id_h_uen,
          segment_id: this.iRequisicion.id_h_line
        }
      },
      cc_params () {
        return {
          unit_id: this.iRequisicion.id_h_uen,
          segment_id: this.iRequisicion.id_h_line,
          prj_id: this.iRequisicion.id_h_operation
        }
      },
      officeParams () {
        return {use_office: true, id_company: this.iRequisicion.id_company ? this.iRequisicion.id_company : -1}
      },
      ccParams () {
        return {use_cc: true, office_id: this.iRequisicion.office_id ? this.iRequisicion.office_id : -1}
      },
      jobParams () {
        return {id_cc: this.iRequisicion.cc_id ? this.iRequisicion.cc_id : -1}
      },
      infoCc () {
        if (!JsUtils.isEmpty(this.centroCostoSeleccionado)) {
          let unitName = this.centroCostoSeleccionado.unit_name
          let segmentName = this.centroCostoSeleccionado.segment_name
          let prjName = this.centroCostoSeleccionado.prj_name
          let jefeName = this.centroCostoSeleccionado.emp_desc

          return `<strong>${this.$t('PERSONALIZACION_CENTRO_COSTO_UNIDAD')}:</strong> ${unitName} <br/>
                  <strong>${this.$t('PERSONALIZACION_CENTRO_COSTO_SEGMENTO')}:</strong> ${segmentName} <br/>
                  <strong>${this.$t('PERSONALIZACION_CENTRO_COSTO_PROYECTO')}:</strong> ${prjName} <br/>
                  <strong>${this.$t('Jefe')}:</strong> ${jefeName}`
        }
        return ''
      },
      reqRechazada () {
        return this.iRequisicion.status === this.status.REQUISICIONES_ETAPA_RECHAZADA
      },
      reqCerrada () {
        return this.iRequisicion.status === this.status.REQUISICIONES_ETAPA_CERRADA
      },
      mostrarOcupanteAnerior () {
        return this.iRequisicion.motivoSolicitudSeleccionado && this.iRequisicion.motivoSolicitudSeleccionado.equivalency === 'S'
      },
      reqMotParams () {
        return {
          h_lookup_type: 'MOTIVO_REQUISICION',
          id_h_lookup_father: (this.iRequisicion.req_type_id) || -1
        }
      },
      creationDate () {
        console.log('generando creationDate')
        if (JsUtils.isEmpty(this.iRequisicion)) {
          return ''
        }

        return moment(this.iRequisicion.creation_date).format('YYYY-MM-DD')
      },
      requiereVista () {
        return this.iRequisicion.requiere_visita > 0 ? 'SI' : 'NO'
      },
      salarioPer () {
        return this.iRequisicion.custom_salary > 0 ? 'SI' : 'NO'
      }
    },
    watch: {
      requisicion () {
        this.iRequisicion = {...this.requisicion, ddSaari: this.requisicion.salary}
        this.setDefault()
        this.loadHistorico()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/Requisiciones/GestionarRequisicion.vue